import { type IFlowAction } from 'widgets/Flow'
import { type ISmartCallFlowActionType } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/type.ts'

export const getActionAndParentActionsByIdAndType = ({
  id,
  getActionById,
  type,
}: {
  id: string
  getActionById: (id: string) => IFlowAction | undefined
  type: ISmartCallFlowActionType
}) => {
  const actions: IFlowAction[] = []
  const ids: string[] = []
  const findAction = (id: string) => {
    ids.push(id)
    const action = getActionById(id)
    if (action?.actionStore.type === type) {
      actions.push(action)
    }
    if (!action?.actionStore.parentId) return
    findAction(action.actionStore.parentId)
  }
  findAction(id)
  return { actions, ids }
}
